/**
 *
 * @constructor
 */
class ContactSelectbox {
  constructor() {
    this._target = '.js-contactSelectbox';
    this._color = '#333';
    this.init();
  }

  /**
   * お問い合わせページのセレクトボックスの文字色の制御
   */
  init() {
    if (document.querySelector(this._target)) {
      this.contactSelectbox(this._target, this._color);
    }
  }

  /**
   * お問い合わせページのセレクトボックスの文字色を制御するメソッド
   * @param {string} target - セレクトボックスのセレクタ
   * @param {string} targetColor - 設定する文字色
   */
  contactSelectbox(target, targetColor) {
    const elem = document.querySelector(target);
    elem.addEventListener('change', () => {
      // セレクトボックスの選択値に応じて文字色を変更
      elem.style.color = (elem.value === '') ? '' : targetColor;
    });
  }
}

export default ContactSelectbox;
